<mat-form-field appearance="fill">
    <mat-label>{{ _label }}</mat-label>
    <input matInput [matDatepicker]="picker" [(ngModel)]="_value" [name]="_name" [max]="_maxDate" [min]="_minDate" [disabled]="_disabled || _readOnly" (ngModelChange)="onDateUpdated($event)" [required]="isRequired" [errorStateMatcher]="errorStateMatcher" readonly/>
    <mat-datepicker-toggle color="accent" matIconSuffix [for]="picker"/>
    <mat-datepicker #picker/>
</mat-form-field>
@if (hasError) {
    <div class="error-message">{{ errorMessage }}</div>
}

